import { DoorOpen } from 'lucide-react';
import { ClassroomsGrid } from '@/components/common/ClassroomsGrid';
import type { Classroom, EstablishmentFormState } from '@/types/establishment.types';

/** Props for {@link EstablishmentClassroomsSection}. */
interface Props {
  form: EstablishmentFormState;
  onFieldChange: (field: string, value: unknown) => void;
}

/** Classrooms list on the establishment form. */
export function EstablishmentClassroomsSection({ form, onFieldChange }: Readonly<Props>) {
  function handleClassroomsChange(classrooms: Classroom[]): void {
    onFieldChange('classrooms', classrooms);
  }

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <DoorOpen className="w-4 h-4" />
        Salles
      </h4>
      <ClassroomsGrid value={form.classrooms} onChange={handleClassroomsChange} disabled={false} />
      <p className="text-xs text-muted-foreground mt-2">
        Les salles peuvent être modifiées par les Superadmins, les Coordinateurs et les Managers.
      </p>
    </div>
  );
}
